module.exports = __webpack_public_path__ + "img/oth9.5a6479c4.png";